// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@awc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@awc/Overrides/Components/CartTotalDisplay";
import { color, mergeWithCss } from "@awc/XDL/Utilities";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.mainContainer, {
        css: css`
            @media print {
                border: 2px solid ${color("common.border")};
            }
        `,
    }),
};

cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};
cartTotalDisplayStyles.orderFeeLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.orderFeeValue = {
    ...orderTotalDisplaySharedStyles.value,
};
